// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export default function RorIcon(props:React.HTMLAttributes<HTMLOrSVGElement>) {
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 20 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 7L7.4641 1.75H0.535898L4 7Z" fill="currentColor"/>
      <path d="M4 15L7.4641 20.25H0.535898L4 15Z" fill="currentColor"/>
      <path d="M16 7L19.4641 1.75H12.5359L16 7Z" fill="currentColor"/>
      <path d="M16 15L19.4641 20.25H12.5359L16 15Z" fill="currentColor"/>
    </svg>
  )
}
